import { selectWarehouseIndex } from '../Warehouses/warehousesSlice'
import { useRouteMatch, useHistory } from 'react-router-dom'
import SlideShow from '../Warehouses/SlideShow'
import { useReduxSelector } from 'store'
import React from 'react'

interface WarehouseSlidesProps {
  id: string
}

const WarehouseSlides: React.FC<WarehouseSlidesProps> = ({ id }) => {
  const index = useReduxSelector(state => selectWarehouseIndex(state, id))
  const { path } = useRouteMatch()
  const { replace } = useHistory()

  return (
    <SlideShow
      actionInAllSlides
      startIndex={index}
      action={(warehouseId) => {
        if (warehouseId !== id) {
          replace(path.replace(':id', warehouseId))
        }
      }} />
  )
}

export default WarehouseSlides